'use client';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import style from './LoadingBasic.module.scss.mjs';

const cx = classNames.bind(style);
/**
 * 도트형 기본 로딩 컴포넌트
 *
 * - `@defign/asset`의 `AniLoadingData`와 기능상 완전히 동일합니다.
 * - `@defign/asset@^3.0.0`부터 `AniLoadingData`는 제거되었습니다. `LoadingBasic`으로 교체해주세요.
 */
const LoadingBasic = /*#__PURE__*/memo(_ref => {
  let {
    fill = 'rgb(3,199,90)',
    fill2 = 'rgb(2,177,145)',
    fill3 = 'rgb(0,154,199)',
    width = '100%',
    height = '100%',
    viewBox = '0 0 38 10'
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: cx('loadingBasic'),
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: width,
    height: height,
    viewBox: viewBox
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar2_ts'),
    transform: "translate(5,5) scale(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar2'),
    r: "5",
    transform: "translate(0,0)",
    opacity: "0",
    fill: fill,
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('bar3_to'),
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar3_ts'),
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar3'),
    r: "5",
    transform: "translate(0,0)",
    opacity: "0",
    fill: fill2,
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('bar4_to'),
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar4_ts'),
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar4'),
    r: "5",
    transform: "translate(0,0)",
    opacity: "0",
    fill: fill3,
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('bar5_ts'),
    transform: "translate(33,5) scale(1,1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar5'),
    r: "5",
    transform: "translate(0,0)",
    fill: fill3,
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('bar6_to'),
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar6_ts'),
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar6'),
    r: "5",
    transform: "translate(0,0)",
    fill: fill,
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('bar7_to'),
    transform: "translate(19,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar6_ts'),
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar7'),
    r: "5",
    transform: "translate(0,0)",
    fill: fill2,
    stroke: "none",
    strokeWidth: "1"
  }))));
});

export { LoadingBasic as default };
